// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Hagrid from 'vue-hagrid';
import VueClipboard from 'vue-clipboard2';
import App from './App';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

Vue.use(Hagrid);
Vue.use(VueClipboard);

window.app = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store,
});



// WEBPACK FOOTER //
// ./src/main.js